export const getBeaBasePath = (appId: string) => {
  const beaGraphql = `${globalThis.CONFIG.backends?.default ?? ''}/graphql`;
  const beaUrl = new URL(beaGraphql, window.location.href);

  return new URL(`/api/frontend/configuration/${appId}/`, beaUrl).toString();
};
